import React, { Fragment } from "react";
import { Link } from "gatsby";

const Sidebar = ({ categories }) => {
  return (
    <Fragment>
      <h3 className="mb-4 font-canossaBd text-2xl text-secondary">
        Categories
      </h3>
      <div>
        {categories.map((category, index) => (
          <div
            key={index}
            className={`p-3 ${
              index % 2 === 0 ? "bg-submenugrey" : "bg-greycustom"
            }`}
          >
            <Link to={category.uri}>{category.name}</Link>
          </div>
        ))}
      </div>
    </Fragment>
  );
};

export default Sidebar;
